import { UseToggle } from "@/shared/base/hooks/useToggle";
import { ActionModal } from "@/shared/base/components/ActionModal/ActionModal";
import { Box, Stack, Typography } from "@mui/material";
import { Divider } from "@/shared/base/components/Divider/Divider";
import { ModalActionButton } from "@/shared/base/components/ModalActionButton/ModalActionButton";
import { useCartNavigationHelper } from "../../../useCartBackButtonHelper";

export function ServiceFeeErrorModal(props: { modalProps: UseToggle }) {
  const { modalProps } = props;
  const { backToFindGames } = useCartNavigationHelper();

  return (
    <ActionModal
      isOpen={modalProps.open}
      onClose={backToFindGames}
      renderHeader={() => {
        return (
          <Box py={2} px={3}>
            <Typography
              variant="subtitle1"
              color="text.primary"
              fontWeight={600}
            >
              Timeout
            </Typography>
          </Box>
        );
      }}
      renderBody={() => {
        return (
          <Box>
            <Divider />
            <Box p={3}>
              <Typography variant="body1" color="text.secondary">
                Your transaction could not be completed at this time. Please try
                again later.
              </Typography>
            </Box>
            <Divider />
          </Box>
        );
      }}
      renderFooter={() => {
        return (
          <Stack
            p={2}
            direction={"row"}
            justifyContent={"flex-end"}
            spacing={2}
          >
            <Box width={"120px"}>
              <ModalActionButton variant="primary" onClick={backToFindGames}>
                Close
              </ModalActionButton>
            </Box>
          </Stack>
        );
      }}
    />
  );
}
